export const registerRoute = `${process.env.REACT_APP_HOST}/register`;
export const loginRoute = `${process.env.REACT_APP_HOST}/login`;
export const insertAvatarRoute = `${process.env.REACT_APP_HOST}/insertAvatar`;
export const addTask = `${process.env.REACT_APP_HOST}/messages/insertAdd`;
export const getAllMessages = `${process.env.REACT_APP_HOST}/messages/getAllMessages`;
export const getUserProfile = `${process.env.REACT_APP_HOST}/getUserProfile`;
export const getContacts = `${process.env.REACT_APP_HOST}/getContacts`;

export const urlAvatarApi = "https://api.multiavatar.com/";
